import React from 'react';

export default function ElegantAddButton({text, onClick}) {
  const navigate = (path) => {
    console.log(`Navigating to: ${path}`);
  };

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#f9fafb'
    },
    button: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 24px',
      background: 'var(--card-bg, white)',
      color: '#374151',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      fontSize: '15px',
      fontWeight: '500',
      cursor: 'pointer',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.2s ease',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    icon: {
      width: '16px',
      height: '16px',
      transition: 'transform 0.2s ease'
    }
  };

  const [isHovered, setIsHovered] = React.useState(false);

  const buttonStyle = {
    ...styles.button,
    ...(isHovered && {
      borderColor: '#d1d5db',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      background: 'linear-gradient(to right, #eff6ff, #eef2ff)'
    })
  };

  const iconStyle = {
    ...styles.icon,
    ...(isHovered && {
      transform: 'rotate(90deg)'
    })
  };

  return (
    // <div style={styles.container}>
      <button
        style={buttonStyle}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <svg style={iconStyle} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"/>
        </svg>
        <span>{text}</span>
      </button>
    // </div>
  );
}